import globals from "../globals.js"
import axios from "axios"
export default {
    data(){
        return{
            customer_list: []
        }
    },
    methods: {
        async getProductsPurchasedAndNotPurchased(params) {
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.get(globals.AUTH_SERVICE + `/products/list?skip=${params.skip}&limit=${params.limit}`)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data)
                }
            })
        },
        async getCustomerDetails(customer_id) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.get(global.CRM_API + "/customers/get?id=" + customer_id)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                } catch (error) {
                }
            })
        },
        async getCompanyDetails(id) {
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.get(globals.AUTH_SERVICE + '/company/'+id)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data)
                }
            })
        },
    }
}


// WEBPACK FOOTER //
// ./src/components/mixins/crm.js